export default __webpack_public_path__ + "static/media/nocard.90f21643.svg";